import { render, staticRenderFns } from "./PackagePaymentVirtualModal.vue?vue&type=template&id=f28e8544&scoped=true"
import script from "./PackagePaymentVirtualModal.vue?vue&type=script&lang=ts"
export * from "./PackagePaymentVirtualModal.vue?vue&type=script&lang=ts"
import style0 from "./PackagePaymentVirtualModal.vue?vue&type=style&index=0&id=f28e8544&prod&scoped=true&lang=css"
import style1 from "./PackagePaymentVirtualModal.vue?vue&type=style&index=1&id=f28e8544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28e8544",
  null
  
)

export default component.exports